import { INSTRUMENT_VERSION, QUESTIONS } from "../data/review";

export const STORAGE_KEY = "bos-ocr-v2.2.0";
export const LEGACY_STORAGE_KEYS = ["bos-ocr-v1.2.0", "bos-ocr-v2.1.0"];

export const getNextStep = (questionIndex, questionCount = QUESTIONS.length) =>
  questionIndex === questionCount - 1 ? "review" : questionIndex + 1;

export const canCalculate = (answers) =>
  QUESTIONS.every((question) => answers[question.id] !== undefined);

export const loadReviewSession = (storage) => {
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed.instrumentVersion !== INSTRUMENT_VERSION) {
        storage.removeItem(STORAGE_KEY);
        return { session: null, resetRequired: true };
      }
      return { session: parsed, resetRequired: false };
    }
    const legacyKeys = LEGACY_STORAGE_KEYS.filter((key) => storage.getItem(key));
    legacyKeys.forEach((key) => storage.removeItem(key));
    return { session: null, resetRequired: legacyKeys.length > 0 };
  } catch {
    return { session: null, resetRequired: false };
  }
};
